'use client';
import { ModalHeader } from '@/components/molecules';

interface ModalWrapperProps {
	title: string;
	className?: string;
	onClose: () => void;
	children: React.ReactNode;
	closeOnOutsideClick?: boolean;
	overlayClassName?: string;
	showModalHeader?: boolean;
}

export const ModalWrapper = ({
	title,
	className,
	onClose,
	children,
	closeOnOutsideClick = true,
	overlayClassName,
	showModalHeader = true
}: ModalWrapperProps) => {
	const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (closeOnOutsideClick && e.target === e.currentTarget) {
			e.preventDefault();
			e.stopPropagation();
			onClose();
		}
	};

	return (
		<div
			className={`fixed inset-0 z-50 flex items-center justify-center bg-black/50 ${overlayClassName}`}
			onClick={handleBackdropClick}
			role="presentation"
		>
			<div
				className={`scrollbar-thin max-h-[450px] overflow-auto sm:max-h-[600px] !mx-5 flex h-auto w-full max-w-96 flex-col rounded-lg bg-white p-6 shadow-xl ${className}`}
				onClick={(e) => e.stopPropagation()}
				role="dialog"
				aria-modal="true"
			>
				{showModalHeader && <ModalHeader title={title} onClose={onClose} />}
				<div>{children}</div>
			</div>
		</div>
	);
};
